var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-sample-recollect-detail',{staticClass:"pt-sample-recollect-detail__page",attrs:{"sampleId":_vm.sampleId,"sampleType":_vm.sampleType}})}
var staticRenderFns = []

export { render, staticRenderFns }